var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLakeSurface = function SvgLakeSurface(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 766,
    height: 234,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#538FFF",
    stroke: "#000",
    d: "M766 236V2a1 1 0 0 0-1-1H335.421c-.465 0-.865.284-.937.743C331.678 19.56 360.336 92.89 228 114.5 95.062 136.209 18.034 191.9 1.478 235.693c-.244.645.245 1.307.935 1.307H765a1 1 0 0 0 1-1Z"
  })));
};
export default SvgLakeSurface;